<form [formGroup]="form" class="form" *ngIf="formReady">
  <div class="form-body">
    <div class="form-section">
      <app-form-row [label]="'FORMS.OBJECT.BASIC_INFO.OBJECT_NUMBER' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'objectNumber'" [placeholder]="(objekt && objekt.id ? objekt.id : '')">
        </app-input>
      </app-form-row>
      <app-form-row [label]="'FORMS.OBJECT.BASIC_INFO.NAME' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'name'">
        </app-input>
      </app-form-row>

      <app-form-row
        [label]="['FORMS.OBJECT.BASIC_INFO.TENDER_NR', 'FORMS.OBJECT.BASIC_INFO.TENDER_NAME'] | translateControl : form | async">
        <div class="row">
          <div class="col-md-3">
            <app-input [type]="'text'" [mainForm]="form" [controlName]="'tenderNr'">
            </app-input>
          </div>
          <div class="col-md-9">
            <app-input [type]="'text'" [mainForm]="form" [controlName]="'tenderName'">
            </app-input>
          </div>
        </div>
      </app-form-row>

      <app-form-row
        [label]="['FORMS.ADDRESS.STREET_NAME', 'FORMS.ADDRESS.STREET_NR'] | translateControl : addressForm | async">
        <div class="row">
          <div class="col-8">
            <app-input [type]="'text'" [mainForm]="addressForm" [controlName]="'streetName'">
            </app-input>
          </div>
          <div class="col-4">
            <app-input [type]="'text'" [mainForm]="addressForm" [controlName]="'streetNr'">
            </app-input>
          </div>
        </div>
      </app-form-row>

      <app-form-row
        [label]="['FORMS.ADDRESS.ZIP_CODE', 'FORMS.ADDRESS.CITY', 'FORMS.ADDRESS.COUNTRY'] | translateControl : addressForm | async">
        <div class="row">
          <div class="col-3">
            <app-input [type]="'text'" [mainForm]="addressForm" [controlName]="'zipCode'">
            </app-input>
          </div>
          <div class="col-5">
            <app-input [type]="'text'" [mainForm]="addressForm" [controlName]="'city'">
            </app-input>
          </div>
          <div class="col-4">
            <app-dropdown [options]="dropdownData.countries" [labelKey]="'title'" [valueKey]="'value'"
              [mainForm]="addressForm" [controlName]="'country'" [searchable]="true" [defaultValue]="dropdownData.countries[0].value">
            </app-dropdown>
          </div>
        </div>
      </app-form-row>

      <app-form-row [label]="'FORMS.OBJECT.BASIC_INFO.TRANSACTION_TYPE' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'transactionType'">
        </app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.OBJECT.BASIC_INFO.SUBMISSION' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'submission'">
        </app-input>
      </app-form-row>

    </div>

    <ng-container *ngFor="let additionalAddressForm of additionalAddresses.controls; let i=index">
      <app-objekt-basic-info-additional-address *ngIf="!additionalAddressForm.value.deleteOnUpdate"
        [form]="additionalAddressForm" (addressRemoved)="onRemoveAdditionalAddress(i)">
      </app-objekt-basic-info-additional-address>
    </ng-container>

  </div>

  <ng-container *ngIf="canUpdateObjekt">
    <app-button-dropdown [buttonText]="'+ ' + ('FORMS.OBJECT.BASIC_INFO.ADD_ADDRESS' | translate)"
      (itemSelected)="addAdditionalAddress($event)" [items]="dropdownData.additionalAddressTypes">
    </app-button-dropdown>
  </ng-container>
</form>
